import { borderWidth } from '../constants.js';
import { palette } from '../palette/index.js';

const createFocusStyle = (borderColor, ringColor)=>({
        boxShadow: `0 0 0 ${borderWidth.hairline} ${borderColor}, 0 0 0 1px ${palette.gray1}, 0 0 0 2px ${ringColor}`
    });
const subtleValidFocusStyle = `0 0 0 ${borderWidth.hairline} ${palette.gray8}`;
const subtleInvalidFocusStyle = `0 0 0 ${borderWidth.hairline} ${palette.red8}`;
const invalidFocusStyle = createFocusStyle(palette.red6, palette.red9);
const validFocusStyle = createFocusStyle(palette.gray6, palette.blue10);
// Empty implementation to maintain backward compatibility without ring functionality
const focusStyles = ()=>({
        ring: {},
        transition: ""
    });

export { focusStyles, invalidFocusStyle, subtleInvalidFocusStyle, subtleValidFocusStyle, validFocusStyle };
